export default __webpack_public_path__ + "dc6b6d0f5a58b32e615f15cae836fd3f.png";